import React, { useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import AttachmentsPage from "../../Pages/AttachmentsAndPledgePage/Attachments";
import PledgeAndAcknowledgement from "../../Pages/AttachmentsAndPledgePage/PledgeAndAcknowledgement";
import PopupAHSF from "../../Components/PopupAHSF";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { useDispatch, useSelector } from "react-redux";
import { GetValidateAllPages } from "../../Redux/Reducers/ValiadateAllPages";
import { ChangeApplicationStatus } from "../../Redux/Reducers/ApplicationInformation";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { AddFlowSubmitter } from "../../Redux/Reducers/FlowSubmitter/AddFlowSubmitter";
import FindOutAwardPage from "../../Pages/AttachmentsAndPledgePage/FindOutAwardPage";
function Attachments() {
  // State for managing popup visibility
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);
  
  // State to prevent multiple form submissions
  const [isSubmitting, setIsSubmitting] = useState(false);

  const dispatch = useDispatch(); // Redux hook to dispatch actions
  const navigat = useNavigate(); // React Router hook for navigation
  
  const state = useSelector((state) => {
    // Extracting necessary pieces of Redux state
    return {
      ValidateAllPages: state.ValidateAllPages.ValidateAllPages, // Validation data for all pages
      ActiveRound: state.ApplicationInformation.ActiveRound, // Currently active round information
      ApplicationInformation: state.ApplicationInformation.ApplicationInformation, // Application data
      FlowSubmitter: state.FlowSubmitter.FlowSubmitter, // Workflow state
      loadingAddFlowSubmitter: state.FlowSubmitter.loadingAddFlowSubmitter, // Workflow submission loading status
    };
  });

  // Function to save data and handle validations
  const SaveDataPage = async (withValidate) => {
    if (isSubmitting) return; // Prevent multiple submissions
    setIsSubmitting(true); // Mark submission in progress

    const validate = await dispatch(
      GetValidateAllPages(localStorage.getItem("aI_ApplicationInformationId")) // Validate all pages
    );

    if (Object.keys(validate.payload).length === 0) {
      // If validation passes
      const updated = await dispatch(
        ChangeApplicationStatus({
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId" // Fetch application ID
          ),
          aI_ApplicationStatusId: "eeeaedea-3434-4384-97d7-e795f6aa2b22", // Set status to "under review"
        })
      );

      if (updated.payload) {
        // If status update succeeds
        let condition =
          state.ApplicationInformation?.aI_ApplicationStatusId ===
          "bbad6edf-0d73-4478-b33d-68f9c777d438"; // Check if status is "edit in progress"

        if (
          state.ApplicationInformation?.aI_ApplicationStatusId ===
          "ea0300ee-f64d-441e-ad47-f2a2b9adf293" // If status requires workflow submission
        ) {
          await dispatch(
            AddFlowSubmitter(
              localStorage.getItem("aI_ApplicationInformationId") // Submit workflow
            )
          );
        }

        Swal.fire({
          // Display success message
          position: "center",
          icon: "success",
          title: condition ? "تم تعديل طلبك بنجاح" : "تم تقديم طلبك بنجاح",
          showConfirmButton: false,
          timer: 2000, // Auto-close after 2 seconds
        }).then(() => {
          window.location.replace("/grants/mainpage"); // Redirect to main page
        });
      }
    } else {
      setisPopupOpenStatus(true); // Show validation errors popup
    }

    setIsSubmitting(false); // Reset submission state
  };

  // Condition to determine if fields should be disabled
  const shouldDisableFields = !(
    state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId && // Active round check
    state.ApplicationInformation?.aI_ApplicationStatus?.canEdite && // Edit permission check
    window.location.href.includes("manager") == false // Manager access restriction
  );




  return (
    <>
      {/* Attachments and acknowledgments components */}
      <AttachmentsPage />
      <FindOutAwardPage/>
      <PledgeAndAcknowledgement />

      {!shouldDisableFields ? (
        // Render submit button if fields are enabled
        <div className="containerButtonMAin">
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              SaveDataPage(true); // Save data with validation
            }}
            disabled={isSubmitting} // Disable button if submission in progress
            title={
              state.ApplicationInformation?.aI_ApplicationStatusId ==
              "bbad6edf-0d73-4478-b33d-68f9c777d438" // Conditionally set button title
                ? "تعديل"
                : "تقديم"
            }
            text={
              state.ApplicationInformation?.aI_ApplicationStatusId ==
              "bbad6edf-0d73-4478-b33d-68f9c777d438" // Conditionally set button text
                ? "تعديل"
                : "تقديم"
            }
            show={true}
          />
        </div>
      ) : (
        ""
      )}

      {/* Popup for validation errors */}
      <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus} // Popup visibility state
        isPopupOpenFunction={() => setisPopupOpenStatus(false)} // Function to close popup
        forValidateAllPages={true} // Indicates the popup is for page validation
        maxWidth="50%" // Popup width
        title="يرجى تعبئة الحقول المطلوبة" // Popup title
        componentBody={state.ValidateAllPages} // Validation errors content
      />
    </>
  );
}
export default Attachments;
